"use client"

import { BlockchainFiltersMoleculeReatom } from "@/app/blockchains/filters/blockchain-filters-molecule.reatom"
import { Image } from "@/app/components/image"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { BrandsMolecule } from "./brands-molecule"

interface Props {
  className?: string
}

interface Brand {
  url: string
  image: string
}

export const BrandsView = reatomComponent(({ className }: Props) => {
  const { selectedBlockchain } = useMolecule(BlockchainFiltersMoleculeReatom)
  const blockchain = selectedBlockchain()

  // Only show on "ALL" blockchain view
  if (blockchain !== "ALL") return null

  return (
    <div className={className}>
      <BrandsContent />
    </div>
  )
}, "BrandsView")

function BrandsContent() {
  const { brandsQueryParamsAtom } = useMolecule(BrandsMolecule)
  const queryParams = brandsQueryParamsAtom()
  const { data: brands } = useSuspenseQuery<Brand[]>(queryParams)

  if (!brands || brands.length === 0) {
    return null
  }

  return (
    <>
      <h4 className="mb-8 font-medium text-xl">Trusted by</h4>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
        {brands.map((brand, index) => (
          <a
            key={`${brand.url}-${index}`}
            href={brand.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group"
          >
            <div className="overflow-hidden rounded-lg border border-foreground/10 bg-card md:rounded-xl">
              <Image
                imageSrc={brand.image}
                alt={`Brand ${index + 1}`}
                containerClassName="aspect-[8/5]"
                className="w-full object-cover transition-transform"
              />
            </div>
          </a>
        ))}
      </div>
    </>
  )
}

export function BrandsSkeleton() {
  return (
    <BrandsContainer>
      <Skeleton className="h-full w-full" />
    </BrandsContainer>
  )
}

function BrandsContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative aspect-[21/5] min-h-[300px] w-full overflow-hidden rounded-lg md:rounded-xl">
      {children}
    </div>
  )
}
